export default __webpack_public_path__ + "static/media/bunnies.d7d60ebb.png";